import { Injectable } from '@angular/core';

import { ROUTING_PATH } from '@shared/constants/routingPath';

import {
  TrialInsightsRemainingSpendKey,
  TrialInsightsTableModel,
  TrialInsightsTableOptions,
  TrialInsightsTableRowData,
} from '../../models/trial-insights-table.model';

@Injectable({
  providedIn: 'root',
})
export class TrialInsightsRemainingSpendTableService implements TrialInsightsTableModel {
  route = ROUTING_PATH.BUDGET.INDEX;
  subRoute = ROUTING_PATH.BUDGET.INDEX;

  createTable = (
    selectedKey: TrialInsightsRemainingSpendKey = TrialInsightsRemainingSpendKey.REMAINING_SPEND,
    rowData: TrialInsightsTableRowData[] = []
  ): TrialInsightsTableOptions => {
    return {
      buttons: {
        data: [{ key: TrialInsightsRemainingSpendKey.REMAINING_SPEND, value: 'Vendor Contract' }],
        defaultButtonKey: selectedKey,
        display: true,
      },
      header: {
        data: [
          {
            buttonKey: TrialInsightsRemainingSpendKey.REMAINING_SPEND,
            leftValue: 'Vendor Contract',
            rightValue: 'Remaining $',
          },
        ],
        display: true,
      },
      link: {
        display: true,
        url: `/${this.route}/${this.subRoute}`,
        value: 'View Vendor Budget',
      },
      rowData: {
        compact: false,
        data: rowData,
      },
    };
  };
}
